import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue-demi";

interface DevInfoProps {
  mocksStatus?: string;
  versionInfo?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DevModeInfo',
  props: {
    mocksStatus: null,
    versionInfo: null
  },
  setup(__props: any) {

const props = __props as {
  mocksStatus?: string;
  versionInfo?: string;
};


const info = computed(() => [
    {
      label: 'Version',
      value: props.versionInfo,
    },
    {
      label: 'Mocks',
      value: props.mocksStatus,
    }
  ].filter(i => i.value))

const isOpen = ref(false);
const toggle = () => isOpen.value = !isOpen.value;

return { __sfc: true,props, info, isOpen, toggle }
}

})